import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ExerciseCard from "../../components/ExerciseCard/ExerciseCard";
import EmptyListState from "../EmptyListState/EmptyListState";
import { PlusIcon } from "@heroicons/react/24/outline";
import { ClipLoader } from "react-spinners";

const ExerciseList = (props) => {
  const currentWorkout = props.currentWorkoutAndExercises;
  if (!currentWorkout) return;

  const exercises = currentWorkout.exercises;

  const handleExerciseDragAndDrop = (results) => {
    const { source, destination } = results;

    if (!destination) return;
    if (source.index === destination.index) return;

    const reorderedExercises = [...exercises];
    const [movedExercise] = reorderedExercises.splice(source.index, 1);
    reorderedExercises.splice(destination.index, 0, movedExercise);
    props.onExercisesReordered(reorderedExercises);
  };

  return (
    <div className="px-2">
      {exercises.length === 0 && (
        <EmptyListState
          title="No exercises"
          message={"Start tracking by adding a new exercise."}
        />
      )}

      {exercises.length > 0 && (
        <DragDropContext onDragEnd={handleExerciseDragAndDrop}>
          <Droppable droppableId="ROOT" type="group">
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {exercises.map((exercise, index) => {
                  return (
                    <Draggable
                      draggableId={exercise._id}
                      key={exercise._id}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          ref={provided.innerRef}
                          className="mb-1"
                        >
                          <ExerciseCard
                            key={exercise._id}
                            {...exercise}
                            onDeleteExercise={props.onDeleteExercise}
                          />
                        </div>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}
      <div className="pt-2 pb-4 w-full">
        <button
          type="button"
          className="group relative flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:pointer-events-none"
          disabled={props.createExerciseLoading}
          onClick={props.onExerciseCreated}
        >
          {props.createExerciseLoading ? (
            <ClipLoader
              color="rgb(white)"
              speedMultiplier={0.6}
              size={"1.25rem"}
            />
          ) : (
            <>
              Add Exercise
              <span className="flex items-center pl-2">
                <PlusIcon className="h-5 w-5 text-white" aria-hidden="true" />
              </span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default ExerciseList;
